import React, { useEffect } from 'react';
import Header from "@cloudscape-design/components/header";
import { Box, Link, SpaceBetween } from '@cloudscape-design/components';
import { mdiEmoticonSadOutline  } from '@mdi/js';
import { Icon } from '@mdi/react';
import { getParameter } from '../../pages/commons/functions';


    const handleBack = (ref: string) => {
        window.history.back()
    }
export const Error404 = () => {
    return (
        <SpaceBetween size="s" direction='vertical' alignItems='center'>
            <Header variant="h1">ERROR 404</Header>
            <Icon path={mdiEmoticonSadOutline } size={6} color={"#268cab"} />
            <Header variant="h3">Recurso no se encuentra disponible</Header>
            <Box>x-Route: {getParameter(window.location.hash, "route")}</Box>
            <Link onClick={()=>window.history.back()}>Volver</Link>
        </SpaceBetween>
    );
};
